import { useState } from 'react';
import { NavLink, Link, useLocation } from 'react-router';
import { SITE } from '~/data/site';
import { Lockup } from '~/components/brand/lockup';

/**
 * Header. Logo left, a quote button right. There is no phone number on the site
 * right now: contact is email and the quote form, and the sticky bar carries the
 * email link on small screens.
 */

const NAV = [
  { to: '/services', label: 'Services' },
  { to: '/industries', label: 'Industries' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/why-us', label: 'Why us' },
  { to: '/about', label: 'About' },
];

export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Close the drawer whenever the route changes.
  const [lastPath, setLastPath] = useState(location.pathname);
  if (lastPath !== location.pathname) {
    setLastPath(location.pathname);
    if (open) setOpen(false);
  }

  return (
    <header className="site-header">
      <div className="shell header-inner">
        <Link to="/" className="brand" aria-label={`${SITE.name} — home`}>
          <Lockup />
        </Link>

        <nav className="nav-desktop" aria-label="Main">
          {NAV.map((item) => (
            <NavLink key={item.to} to={item.to} className="nav-link">
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="header-actions">
          {/*
            Log in leaves the domain — the console lives at ssc.broomstack.app,
            not here. A plain <a>, not a <Link>: React Router would try to match
            it as an internal route and 404.

            Deliberately ONE link, to the admin portal, rather than a three-way
            portal picker. Since PR #24 an owner/manager/dispatcher login mints
            the crew session too, so this single door covers everyone who runs
            the company AND works jobs.
            Crew-only and client logins live in the footer, where someone
            looking for them will look, without making every visitor choose.
          */}
          <a className="header-login" href={SITE.console.admin}>
            Log in
          </a>
          <Link to="/quote" className="btn btn-primary">
            Get a quote
          </Link>
          <button
            type="button"
            className="nav-toggle"
            aria-expanded={open}
            aria-controls="mobile-nav"
            aria-label={open ? 'Close menu' : 'Open menu'}
            onClick={() => setOpen((v) => !v)}
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
              {open ? (
                <path d="M4 4l12 12M16 4L4 16" stroke="currentColor" strokeWidth="2" />
              ) : (
                <path d="M2 5h16M2 10h16M2 15h16" stroke="currentColor" strokeWidth="2" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {open && (
        <div className="nav-mobile" id="mobile-nav">
          <div className="shell">
            <ul>
              {NAV.map((item) => (
                <li key={item.to}>
                  <Link to={item.to}>{item.label}</Link>
                </li>
              ))}
              <li>
                <Link to="/service-area">Service area</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
              {/* Same external console link as the desktop header — the drawer is
                  the only nav most phone visitors will ever open. */}
              <li>
                <a href={SITE.console.admin}>Log in</a>
              </li>
            </ul>
          </div>
        </div>
      )}
    </header>
  );
}
